import {creates, hoistCmp} from '@xh/hoist/core';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import {AccountsWidgetModel} from './AccountsWidgetModel';
import './AccountsWidget.scss';

export const accountsWidget = hoistCmp.factory({
    model: creates(() => AccountsWidgetModel),
    render({model}) {
        return panel({
            item: grid()
        });
    }
});
